import { createReducer } from '@reduxjs/toolkit';

import { fetchEntitySuccess } from 'modules/entity/actions';
import { FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILURE } from 'modules/chat/actionTypes';

/**
 * @typedef {boolean} IsLoadingMessagesState
 */

/** @type {IsLoadingMessagesState} */
const initialState = false;

const load = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchEntitySuccess, load)
    .addCase(FETCH_MESSAGES_SUCCESS, reset)
    .addCase(FETCH_MESSAGES_FAILURE, reset);
});
